module.exports = ".learn-more-modal .modal-dialog {\n  max-width: 1000px !important; }\n\n.playpause {\n  background-repeat: no-repeat;\n  height: 192px;\n  width: 192px;\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  margin: auto;\n  background-size: contain;\n  background-position: center;\n  cursor: pointer; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/layout/learn-more-modal.component.scss
// module id = ./src/app/shared/components/layout/learn-more-modal.component.scss
// module chunks = main